import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import moment from 'moment';
import {
    Card, CardContent, Tooltip, Typography, withStyles, Grid, Button
} from '@material-ui/core';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { Message as MessageIcon } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import ReactSelect from "../../../../common/components/UI/Select/ReactSelect";
import SideBar from '../../../../common/components/UI/SideBar/SideBar';
import { AdditionalInfo } from '../../../../common-client2/src/components';
import MaterialTable, { MTableToolbar, MTableBody } from 'material-table';
import EmployeeCalendar from '../EmployeeCalendar';
import ViewHistoryButton from './ViewHistoryButton';
import { HistoryPanel } from '../../../App/components/core'
import { ShiftCardWithTooltip } from '../ShiftCardWithTooltip';
import { ManagerTableViewStyles } from '../../../styles/styles';
import _ from 'lodash';
import { tableIcons } from '../constants'
import { updateFetchSizeOption } from '../actions'
import { RequestStatus, RequestTypes, ShiftSegmentTypeName } from '../../../Enums';
import ManagerWarningContent from '../ManagerWarningContent';
import RequestTypeChip from '../RequestTypeChip';
import './RequestTable.scss';
import { getAsLongDate, getAsLongDateTime, formatAs, getAsStartAndEndTimeFormat, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { MomentFormats } from '../../../utils';
import { GetModifiedBy } from '../helpers/ManageRequests.helper';

const WarnTooltip = withStyles({
    tooltip: {
        backgroundColor: 'white',
        color: '#3A3A3A',
        maxWidth: "520px",
        border: '1px solid #dadde9',
    }
})(Tooltip);

class RequestTable extends React.Component {
    constructor(props) {
        super(props);
        this.theme = createTheme({
            palette: {
                primary: {
                    main: '#66b3ff',
                },
                secondary: {
                    main: '#66b3ff',
                },
            },

        });
        this.state = {
            openActionOptions: false,
            selectedActionIndex: 0,
            isSidePanelOpen: false,
            historyPanelData: []
        }
    }

    getChipClass = (rowData, classes) => {
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                return classes.chipTC;
            case RequestTypes.shiftSwap:
                return classes.chipSS;
            case RequestTypes.openShift:
                return classes.chipOS;
            case RequestTypes.voluntaryTimeOff:
                return classes.chipVTO;
            default:
                return '';
        }
    }

    generateShiftColors = (status, actionType, isReceivingShift) => {
        let color = {};

        switch (status) {
            case 'Refused':
            case 'Submitted':
            case 'Pending':
            case 'Retracted':
                color.bgColor = '#FFF'
                color.color = '#333'
                color.borderColor = '#0A54A2'
                switch (actionType) {
                    case RequestTypes.toCover:
                        color.borderColor = isReceivingShift ? '#ffdd00' : '#0A54A2'
                        break;
                    case RequestTypes.shiftSwap:
                        color.borderColor = isReceivingShift ? '#FF7A59' : '#0A54A2'
                        break;
                    case RequestTypes.openShift:
                        color.borderColor = '#EE0F0F'
                        break;
                    case RequestTypes.voluntaryTimeOff:
                        color.borderColor = '#006600'
                        break;
                    default:
                        break;
                }
                break;
            case 'Approved':
                color.bgColor = '#FFF'
                color.borderColor = '#0A54A2'
                color.color = '#7a7a7a'
                if (actionType === RequestTypes.voluntaryTimeOff) {
                    color.borderColor = '#006600'
                }
                break;
            default:
                color = {
                    color: '#48D960',
                    bgColor: 'transparent',
                    borderColor: '#0A54A2',
                }
        }
        return color;
    }

    handleSelectFetchSize = (target, value) => {
        this.props.updateFetchSizeOption(value);
    }

    generateSchedule = (rowData, type) => {
        const generateScheduleTitle = (shift, transferSegment) => `${(shift.label ? `${shift.label} ` : '')}${getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}${(transferSegment ? ' (x)' : '')}`;
        let shiftOffer, proposalOffer, shiftOffers, paycode;
        let schedule = [];
        let status;
        let shiftOfferStartDateTimeInISO;
        let shiftProposalStartDateTimeInISO;
        switch (rowData.actionType) {
            case RequestTypes.toCover:
                status = rowData.status.label;
                shiftOffer = rowData.shift;
                if (rowData.isPartial) {
                    shiftOffer = rowData.partialShift;
                }
                shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                break;
            case RequestTypes.shiftSwap:
                status = rowData.status.label;
                shiftOffer = rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails;
                proposalOffer = rowData.swapProposalShiftInfo[0].shiftInfo.shiftDetails;
                if (rowData.isPartialOffer) {
                    shiftOffer = rowData.partialOfferShift;
                }
                if (rowData.isPartialProposal) {
                    proposalOffer = rowData.partialProposalShift;
                }
                shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                shiftProposalStartDateTimeInISO = formatAs(proposalOffer.startDateTime, DateFnsFormats.ISO);
                break;
            case RequestTypes.openShift:
                status = rowData.status.label;
                shiftOffer = rowData.shift;
                if (rowData.isPartial) {
                    shiftOffer = rowData.partialShift;
                }
                shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                break;
            case RequestTypes.voluntaryTimeOff:
                status = rowData.status.label;
                shiftOffers = rowData.shifts.map(x => x.shiftInfo.shiftDetails)
                shiftOffer = { id: -1, label: "Not used" }
                paycode =  rowData.paycode
                if (paycode != null) {
                    paycode.startDateTime = paycode.startDate
                    paycode.endDateTime = paycode.endDate
                }
                break;
            default:
                break;
        }

        let color = this.generateShiftColors(status, rowData.actionType, type === 'to')

        switch (status) {
            case 'Approved':
                if (type === 'from') {
                    // First employee schedule generation
                    let employeeFromShifts = rowData.employeeFromSchedule
                    for (let shift of employeeFromShifts) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        switch (rowData.actionType) {
                            case RequestTypes.toCover:
                            case RequestTypes.shiftSwap:
                            case RequestTypes.openShift://should not reach here
                                schedule.push({
                                    id: shift.id,
                                    calendarId: '0',
                                    title: generateScheduleTitle(shift, transferSegment),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: shiftStartDateTimeInISO,
                                    end: shiftStartDateTimeInISO,
                                    customStyle: 'padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: {
                                        ...shift,
                                        status: rowData.status.value
                                    },
                                })
                                break;
                            default:
                                break;
                        }

                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 1px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shiftOffer,
                                    status: rowData.status.value
                                },
                                color: color.color,
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        default:
                            break;
                    }
                }
                else {
                    // Second employee schedule generation
                    let employeeToShifts = rowData.employeeToSchedule
                    for (let shift of employeeToShifts) {
                        if (shift.id !== shiftOffer.id) {
                            const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                            const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                            switch (rowData.actionType) {
                                case RequestTypes.toCover:
                                case RequestTypes.shiftSwap:
                                case RequestTypes.openShift:
                                case RequestTypes.voluntaryTimeOff:
                                    schedule.push({
                                        id: shift.id,
                                        calendarId: '0',
                                        title: generateScheduleTitle(shift, transferSegment),
                                        category: 'time',
                                        dueDateClass: '',
                                        start: shiftStartDateTimeInISO,
                                        end: shiftStartDateTimeInISO,
                                        customStyle: 'padding-left: 5px; padding-right: 5px;',
                                        isReadOnly: true,
                                        raw: {
                                            ...shift,
                                            status: rowData.status.value
                                        }
                                    })
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shiftOffer,
                                    status: rowData.status.value
                                },
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        case RequestTypes.voluntaryTimeOff:
                            if(paycode.payCodeRef !== null){
                                schedule.push({
                                    id: paycode.id,
                                    calendarId: '2',
                                    title: paycode.payCodeRef?.qualifier,
                                    category: 'time',
                                    dueDateClass: '',
                                    start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                    end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: paycode,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            for (const offer of shiftOffers) {
                                const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                                schedule.push({
                                    id: offer.id,
                                    calendarId: '1',
                                    title: generateScheduleTitle(offer, false),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: offerStartDateTimeInISO,
                                    end: offerStartDateTimeInISO,
                                    customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: {
                                        ...offer,
                                        status: rowData.status.value
                                    },
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            break;
                        default:
                            break;
                    }
                }
                break;
            case 'Refused':
            case 'Submitted':
            case 'Pending':
            case 'Retracted':
            default:
                if (type === 'from') {
                    // First employee schedule generation
                    let employeeFromShifts = rowData.employeeFromSchedule
                    for (let shift of employeeFromShifts) {
                        if (shift.id !== shiftOffer.id) {
                            const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                            const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: shift.id,
                                calendarId: '0',
                                title: generateScheduleTitle(shift, transferSegment),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftStartDateTimeInISO,
                                end: shiftStartDateTimeInISO,
                                customStyle: 'border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: shift
                            })
                        }
                    }
                    schedule.push({// Offered shift with grey border
                        id: shiftOffer.id,
                        calendarId: '1',
                        title: generateScheduleTitle(shiftOffer, false),
                        category: 'time',
                        dueDateClass: '',
                        start: shiftOfferStartDateTimeInISO,
                        end: shiftOfferStartDateTimeInISO,
                        customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                        isReadOnly: true,
                        raw: shiftOffer,
                        bgColor: color.bgColor,
                        borderColor: color.borderColor
                    })
                    if (rowData.actionType === RequestTypes.shiftSwap) {
                        const proposalOfferColor = this.generateShiftColors(status, rowData.actionType, true);
                        schedule.push({// Proposed shift with orange dot
                            id: proposalOffer.id,
                            calendarId: '1',
                            title: generateScheduleTitle(proposalOffer, false),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftProposalStartDateTimeInISO,
                            end: shiftProposalStartDateTimeInISO,
                            customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: proposalOffer,
                            color: '#7a7a7a',
                            bgColor: proposalOfferColor.bgColor,
                            borderColor: proposalOfferColor.borderColor
                        })
                    }
                }
                else {
                    // Second employee schedule generation
                    let employeeToShifts = rowData.employeeToSchedule
                    for (let shift of employeeToShifts) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT)
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shift.id,
                            calendarId: '0',
                            title: generateScheduleTitle(shift, transferSegment),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftStartDateTimeInISO,
                            end: shiftStartDateTimeInISO,
                            customStyle: 'padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shift
                        })
                    }
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.openShift:
                            schedule.push({
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: shiftOffer,
                                color: '#7a7a7a',
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            break;
                        case RequestTypes.shiftSwap:
                            schedule.push({// Offered shift with orange dot
                                id: shiftOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(shiftOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftOfferStartDateTimeInISO,
                                end: shiftOfferStartDateTimeInISO,
                                customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: shiftOffer,
                                color: '#7a7a7a',
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            })
                            const proposalOfferColor = this.generateShiftColors(status, rowData.actionType, false)
                            schedule.push({// Proposed shift with grey border
                                id: proposalOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(proposalOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftProposalStartDateTimeInISO,
                                end: shiftProposalStartDateTimeInISO,
                                customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: proposalOffer,
                                bgColor: proposalOfferColor.bgColor,
                                borderColor: proposalOfferColor.borderColor
                            })
                            break;
                        case RequestTypes.voluntaryTimeOff:
                            if(paycode.payCodeRef !== null){
                                schedule.push({
                                    id: paycode.id,
                                    calendarId: '2',
                                    title: paycode.payCodeRef?.qualifier,
                                    category: 'time',
                                    dueDateClass: '',
                                    start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                    end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: paycode,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            for (const offer of shiftOffers) {
                                const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                                schedule.push({
                                    id: offer.id,
                                    calendarId: '0',
                                    title: generateScheduleTitle(offer, false),
                                    category: 'time',
                                    dueDateClass: '',
                                    start: offerStartDateTimeInISO,
                                    end: offerStartDateTimeInISO,
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: offer,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                })
                            }
                            break;
                        default:
                            break;
                    }
                }
                break;
        }
        return schedule;
    }

    handleViewHistoryClick = (rowData) => {
        this.setState({
            isSidePanelOpen: true,
            historyPanelData: rowData.history
        });
    }

    closeSidePanel = () => {
        this.setState({
            isSidePanelOpen: false,
            historyPanelData: []
        });
    }

    render() {
        let { t, classes, data, activeSubmissionPeriodSettingsWithAwarding, signUpRequestSelected, isNonActiveSignUpRequestSelected, fetchResultData, onCheckedRequest } = this.props;
        const { isSidePanelOpen, historyPanelData } = this.state;

        const getRequestDate = (rowData) => {
            switch (rowData.actionType) {
                case RequestTypes.toCover:
                case RequestTypes.openShift:
                    return rowData.shift.startDateTime;
                case RequestTypes.shiftSwap:
                    return rowData.startDate;
                case RequestTypes.voluntaryTimeOff:
                    //rowData.startDate: "2023-11-03T00:00:00+00:00" -> Must remove the +00:00
                    const startDateInLocalTz = new Date(rowData.startDate);
                    const localOffset = startDateInLocalTz.getTimezoneOffset();
                    const startDate = new Date(startDateInLocalTz.getTime() + localOffset * 60000);
                    return startDate;
                default:
                    break;
            }
        }

        return (
            <React.Fragment>
                <MuiThemeProvider theme={this.theme}>
                    <MaterialTable
                        icons={tableIcons}
                        title="Requests"
                        columns={[
                            {
                                title: 'Date submitted',
                                cellStyle: {
                                    whiteSpace: 'nowrap'
                                },
                                render: rowData => {
                                    switch (rowData.actionType) {
                                        case RequestTypes.toCover:
                                        case RequestTypes.openShift:
                                        case RequestTypes.voluntaryTimeOff:
                                            return (
                                                <React.Fragment>
                                                    {getAsLongDateTime(rowData.requestDate)}
                                                </React.Fragment>
                                            )
                                        case RequestTypes.shiftSwap:
                                            return (
                                                <React.Fragment>
                                                    {getAsLongDateTime(rowData.submissionDate)}
                                                </React.Fragment>
                                            )
                                        default:
                                            break;
                                    }
                                },
                                customSort: (a, b) => {
                                    let dateA, dateB;
                                    if (a.actionType === RequestTypes.shiftSwap) {
                                        dateA = formatAs(a.submissionDate, DateFnsFormats.ISO);
                                    }
                                    else {
                                        dateA = formatAs(a.requestDate, DateFnsFormats.ISO);
                                    }

                                    if (b.actionType === RequestTypes.shiftSwap) {
                                        dateB = formatAs(b.submissionDate, DateFnsFormats.ISO);
                                    } else {
                                        dateB = formatAs(b.requestDate, DateFnsFormats.ISO);
                                    }

                                    return dateA < dateB ? -1 : 1
                                },
                            },
                            {
                                title: 'Date requested',
                                cellStyle: {
                                    maxWidth: 20
                                },
                                render: rowData => {
                                    return (
                                        <React.Fragment>
                                            {getAsLongDate(getRequestDate(rowData))}
                                        </React.Fragment>
                                    )
                                },
                                customSort: (a, b) => {
                                    let dateA = formatAs(getRequestDate(a), DateFnsFormats.ISO);
                                    let dateB = formatAs(getRequestDate(b), DateFnsFormats.ISO);

                                    return dateA < dateB ? -1 : 1
                                },
                            },
                            {
                                title: 'Request type',
                                width: '5',
                                maxWidth: '5',
                                render: rowData => (
                                    <React.Fragment>
                                        <RequestTypeChip request={rowData} classes={classes} />
                                    </React.Fragment>
                                ),
                                customSort: (a, b) => a.requestType.localeCompare(b.requestType),
                            },
                            {
                                title: 'Status',
                                headerStyle: {
                                    width: '100px'
                                },
                                sorting: false,
                                render: rowData => (
                                    <div className="table--status-cell">
                                        <Typography component={'h2'} >
                                            {rowData.status.label}
                                        </Typography>
                                        {
                                            (rowData.messages?.length)
                                                ? (
                                                    <AdditionalInfo
                                                        icon={<MessageIcon className="message-icon" />}
                                                        placement="auto"
                                                    >
                                                        {
                                                            rowData.messages.map(log => (
                                                                <div key={`status-cell-message-${log.managerSettingId}-${log?.offerId}-${log?.proposalId}`}>
                                                                    <span className="text-lg-regular">
                                                                        {`${log.employeeName}: "${log.message}"`}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        }
                                                    </AdditionalInfo>
                                                )
                                                : <></>
                                        }
                                    </div>
                                ),
                            },
                            {
                                title: 'Employees',
                                headerStyle: {
                                    width: '1700px'
                                },
                                sorting: false,
                                render: rowData => {
                                    switch (rowData.actionType) {
                                        case RequestTypes.toCover: {
                                            return (
                                                <React.Fragment>
                                                    <Grid container spacing={4}  >
                                                        <Grid item xs={12} >
                                                            <Typography display='inline' className={classes.employeeNameText}>
                                                                {`Employee 1 : ${rowData.employeeFrom.name} `}
                                                            </Typography>
                                                            <Typography display='inline' style={{ paddingLeft: '20px' }} className={classes.employeeNameText}>
                                                                {`Employee 2 : ${rowData.employeeTo.name} `}
                                                            </Typography>
                                                            <ShiftCardWithTooltip
                                                                shift={rowData.shift}
                                                                partialShift={rowData.isPartial ? rowData.partialShift : null}
                                                                actionType={rowData.actionType}
                                                                timeOffRequest={rowData.timeOffRequest}
                                                                isDisplaySegmentInfos={true}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                            );
                                        }
                                        case RequestTypes.shiftSwap:
                                            if (rowData.swapRequestShiftInfo.length <= 1) {
                                                return (
                                                    <React.Fragment>
                                                        <Grid container spacing={4} >
                                                            <Grid item xs={12} >
                                                                <Typography className={classes.employeeNameText}>
                                                                    {`Employee 1 : ${rowData.offerorEmployeeName} `}
                                                                </Typography>
                                                                <ShiftCardWithTooltip
                                                                    shift={rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails}
                                                                    partialShift={rowData.isPartialOffer ? rowData.partialOfferShift : null}
                                                                    actionType={rowData.actionType}
                                                                    isDisplaySegmentInfos={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography className={classes.employeeNameText}>
                                                                    {`Employee 2 : ${rowData.swapProposal.proposalEmployeeName} `}
                                                                </Typography>
                                                                <ShiftCardWithTooltip
                                                                    shift={rowData.swapProposalShiftInfo[0].shiftInfo.shiftDetails}
                                                                    partialShift={rowData.isPartialProposal ? rowData.partialProposalShift : null}
                                                                    actionType={rowData.actionType}
                                                                    isDisplaySegmentInfos={true}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                )
                                            }
                                            else if (rowData.swapRequestShiftInfo.length > 1) {
                                                return (
                                                    <React.Fragment>
                                                        <Grid container spacing={4} >
                                                            <Grid item xs={12} >
                                                                <Typography className={classes.employeeNameText}>
                                                                    {`Employee 1 : ${rowData.offerorEmployeeName} `}
                                                                </Typography>
                                                                <Button className={classes.transparentButtonNoPadding}>
                                                                    <Card className={classes.SSShiftCard}>
                                                                        <CardContent className={classes.fixPadding}>
                                                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                                                {rowData.swapRequestShiftInfo.length + "  Shifts"}
                                                                            </Typography>
                                                                        </CardContent>
                                                                    </Card>
                                                                </Button>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography className={classes.employeeNameText}>
                                                                    {`Employee 2 : ${rowData.swapProposal.proposalEmployeeName} `}
                                                                </Typography>
                                                                <Button className={classes.transparentButtonNoPadding}>
                                                                    <Card className={classes.SSShiftCard}>
                                                                        <CardContent className={classes.fixPadding}>
                                                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                                                {rowData.swapProposalShiftInfo.length + "  Shifts"}
                                                                            </Typography>
                                                                        </CardContent>
                                                                    </Card>
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                )
                                            }
                                            break;
                                        case RequestTypes.openShift: {
                                            return (
                                                <Grid container spacing={4}>
                                                    <Grid item xs={12} >
                                                        <Typography className={classes.employeeNameText}>
                                                            {`Employee: ${rowData.employeeTo.name}`}
                                                        </Typography>
                                                        <ShiftCardWithTooltip
                                                            shift={rowData.shift}
                                                            partialShift={rowData.isPartial ? rowData.partialShift : null}
                                                            actionType={rowData.actionType}
                                                            isApproved={rowData.status.label === RequestStatus.Approved}
                                                            isDisplaySegmentInfos={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            );
                                        }
                                        case RequestTypes.voluntaryTimeOff: {
                                            let shifts = [];
                                            if (rowData.voluntaryTimeOffType === 2) {
                                                shifts = rowData.status.value !== RequestStatus.RetractedSubmitted ? rowData.previousShiftsHistory : (!!rowData.shifts ? rowData.shifts.map(x => x.shiftInfo.shiftDetails) : []);
                                            } else {
                                                shifts = rowData.shifts?.map(x => x?.shiftInfo?.shiftDetails) ?? [];
                                            }
                                            return (
                                                <React.Fragment>
                                                    <Grid container spacing={4} >
                                                        <Grid item xs={12} >
                                                            <Typography className={classes.employeeNameText}>
                                                                {`Employee: ${rowData.employeeTo.name} `}
                                                            </Typography>
                                                            {(!!shifts && shifts.length === 1)
                                                                ? (
                                                                <Typography display='block'>
                                                                    <ShiftCardWithTooltip
                                                                        shift={shifts[0]}
                                                                        actionType={rowData.actionType}
                                                                        isApproved={rowData.status.label === RequestStatus.Approved}
                                                                        isVto={true}
                                                                        isDisplaySegmentInfos={true}
                                                                    />
                                                                </Typography>)
                                                                :
                                                                <Button className={classes.transparentButtonNoPadding}>
                                                                    <Card className={rowData.status.label === RequestStatus.Approved ? classes.VTOShiftCard : classes.VTOShiftCardApproved}>
                                                                        <CardContent className={classes.fixPadding}>
                                                                            <Typography style={{ fontSize: '16px', textAlign: 'left', fontWeight: 'bold' }}>
                                                                                {(shifts?.length ?? 0) + "  Shifts"}
                                                                            </Typography>
                                                                        </CardContent>
                                                                    </Card>
                                                                </Button>}
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                            )
                                        }
                                        default:
                                            break;
                                    }
                                },
                            },
                            {
                                title: 'Warning',
                                field: 'warning',
                                sorting: false,
                                render: rowData => {

                                    switch (rowData.actionType) {
                                        case RequestTypes.toCover:
                                            let warningMsgs;
                                            if (rowData['warnings'].length) {
                                                warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                            }

                                            return (
                                                warningMsgs ?
                                                    <React.Fragment>
                                                        <WarnTooltip
                                                            title={warningMsgs}>
                                                            <Button className={classes.transparentButton}>
                                                                <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                            </Button>
                                                        </WarnTooltip>
                                                    </React.Fragment>
                                                    :
                                                    null
                                            )
                                        case RequestTypes.shiftSwap:
                                            let warningMsgsFrom;
                                            let warningMsgsTo;
                                            if (rowData['warnings'].length) {

                                                const mapWarningToJsx = (warn) => (<ManagerWarningContent warning={warn} classes={classes} />);
                                                const filterOutFalsy = (x) => !!x;

                                                warningMsgsFrom = rowData['warnings']
                                                    ?.filter((warn) => (rowData['offerorEmployeeId'] === warn.employeeId))
                                                    ?.map(mapWarningToJsx)
                                                    ?.filter(filterOutFalsy);

                                                warningMsgsTo = rowData['warnings']
                                                    ?.filter((warn) => (rowData['swapProposal']['proposalEmployeeId'] === warn.employeeId))
                                                    ?.map(mapWarningToJsx)
                                                    ?.filter(filterOutFalsy);
                                            }

                                            return (
                                                (warningMsgsFrom && warningMsgsFrom[0]) || (warningMsgsTo && warningMsgsTo[0]) ?
                                                    <React.Fragment>
                                                        <Grid fixed container spacing={8}  >
                                                            <Grid item xs={12} >
                                                                {
                                                                    warningMsgsFrom[0] ?
                                                                        <React.Fragment>
                                                                            <WarnTooltip
                                                                                title={warningMsgsFrom}>
                                                                                <Button className={classes.transparentButton}>
                                                                                    <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                </Button>
                                                                            </WarnTooltip>
                                                                        </React.Fragment>
                                                                        : null
                                                                }
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {
                                                                    warningMsgsTo[0] ?
                                                                        <React.Fragment>
                                                                            <WarnTooltip
                                                                                title={warningMsgsTo}>
                                                                                <Button className={classes.transparentButton}>
                                                                                    <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                </Button>
                                                                            </WarnTooltip>
                                                                        </React.Fragment>
                                                                        : null
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </React.Fragment>
                                                    :
                                                    null
                                            )
                                        case RequestTypes.openShift:
                                            let warningMsgsOpenShift;
                                            if (rowData['warnings'].length) {
                                                warningMsgsOpenShift = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                            }

                                            return (
                                                warningMsgsOpenShift ?
                                                    <React.Fragment>
                                                        <WarnTooltip
                                                            title={warningMsgsOpenShift}>
                                                            <Button className={classes.transparentButton}>
                                                                <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                            </Button>
                                                        </WarnTooltip>
                                                    </React.Fragment>
                                                    :
                                                    null
                                            )
                                        case RequestTypes.voluntaryTimeOff:
                                            let warningMsgsVto;
                                            if (rowData['warnings'].length) {
                                                warningMsgsVto = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                            }

                                            return (
                                                warningMsgsVto ?
                                                    <React.Fragment>
                                                        <WarnTooltip
                                                            title={warningMsgsVto}>
                                                            <Button className={classes.transparentButton}>
                                                                <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                            </Button>
                                                        </WarnTooltip>
                                                    </React.Fragment>
                                                    :
                                                    null
                                            )
                                        default:
                                            break;
                                    }
                                }

                            },
                            {
                                title: 'Modified by',
                                field: 'approvedByManagerName',
                                sorting: false,
                                render: rowData => {
                                    return (
                                        <React.Fragment>
                                            <Typography>
                                                {GetModifiedBy(rowData.status.value, rowData.approvedByManagerName)}
                                            </Typography>
                                        </React.Fragment>
                                    )
                                },
                            },
                            {
                                sorting: false,
                                render: rowData => (
                                    <ViewHistoryButton onClick={() => this.handleViewHistoryClick(rowData)} />
                                ),
                            }
                        ]}
                        data={data}
                        detailPanel={
                            [
                                rowData => ({
                                    disabled: !rowData.detailPanel,
                                    icon: rowData => { return rowData.rowData.detailPanel ? <FontAwesomeIcon icon={faChevronDown} className={classes.plusMinus} /> : null },
                                    iconProps: { rowData, classes },
                                    openIcon: rowData => { return <FontAwesomeIcon icon={faChevronUp} className={classes.plusMinus} /> },
                                    openIconProps: { classes },
                                    render: rowData => {
                                        switch (rowData.actionType) {
                                            case RequestTypes.toCover:
                                                return (
                                                    <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                        <Grid item xs={1} className={classes.detailPanelShift}>
                                                            <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeFrom.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={11} className={'manager-dashboard'}>
                                                            <EmployeeCalendar schedule={this.generateSchedule(rowData, 'from')} shiftDate={rowData.shift.startDateTime} />
                                                        </Grid>
                                                        <Grid item xs={12} className={classes.divider}></Grid>
                                                        <Grid item xs={1} className={classes.detailPanelShift}>
                                                            <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={11} className={'manager-dashboard'}>
                                                            <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.shift.startDateTime} />
                                                        </Grid>
                                                    </Grid>
                                                )
                                            case RequestTypes.shiftSwap:
                                                if (rowData.swapRequestShiftInfo.length <= 1) {
                                                    return (
                                                        <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.offerorEmployeeName}</Typography>
                                                            </Grid>
                                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                                <EmployeeCalendar schedule={this.generateSchedule(rowData, 'from')} shiftDate={rowData.swapRequestShiftInfo[0].shiftInfo.shiftDetails.startDateTime} />
                                                            </Grid>
                                                            <Grid item xs={12} className={classes.divider}></Grid>
                                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.swapProposal.proposalEmployeeName}</Typography>
                                                            </Grid>
                                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                                <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.swapProposalShiftInfo[0].shiftInfo.shiftDetails.startDateTime} />
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                                else if (rowData.swapRequestShiftInfo.length > 1) {
                                                    return (
                                                        <React.Fragment>
                                                            <Grid container style={{ backgroundColor: '#e4eaf0' }}  >
                                                                <Grid items xs={12} style={{ padding: 5 }} >
                                                                    <MaterialTable
                                                                        icons={tableIcons}
                                                                        title={rowData.offerorEmployeeName}
                                                                        columns={[
                                                                            {
                                                                                title: 'Shift Start Date',
                                                                                cellStyle: {
                                                                                    maxWidth: 20
                                                                                },
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                                        </React.Fragment>
                                                                                    )
                                                                                },
                                                                            },
                                                                            {
                                                                                title: 'Shift',
                                                                                field: 'shiftName',
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <ShiftCardWithTooltip
                                                                                                shift={rowData.shiftInfo.shiftDetails}
                                                                                                actionType={rowData.actionType}
                                                                                            />
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }
                                                                            },
                                                                            {
                                                                                title: 'Location',
                                                                                field: 'location',
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <Typography className={classes.employeeNameText}>
                                                                                                {`${rowData.shiftInfo.shiftDetails.segments[0].orgJobRef.qualifier} `}
                                                                                            </Typography>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }

                                                                            },
                                                                            {
                                                                                title: 'Warning',
                                                                                field: 'warning',
                                                                                headerStyle: {
                                                                                    textAlign: 'center'
                                                                                },
                                                                                render: rowData => {
                                                                                    let warningMsgs;
                                                                                    if (rowData['warnings'].length) {
                                                                                        warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                                                                    }

                                                                                    return (
                                                                                        warningMsgs ?
                                                                                            <React.Fragment>
                                                                                                <WarnTooltip
                                                                                                    title={warningMsgs}>
                                                                                                    <Button className={classes.transparentButton}>
                                                                                                        <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                                    </Button>
                                                                                                </WarnTooltip>
                                                                                            </React.Fragment>
                                                                                            :
                                                                                            null
                                                                                    )
                                                                                }

                                                                            }
                                                                        ]}
                                                                        data={rowData.swapRequestShiftInfo}
                                                                        options={{
                                                                            search: false,
                                                                            paging: false,
                                                                            draggable: false,
                                                                            maxBodyHeight: '68vh',
                                                                            headerStyle: {
                                                                                fontWeight: 900,
                                                                                fontSize: '14px',
                                                                                textDecoration: 'underline',
                                                                            },
                                                                            detailPanelType: 'single',
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid items xs={12} style={{ padding: 5 }} >
                                                                    <MaterialTable
                                                                        icons={tableIcons}
                                                                        title={rowData.swapProposal.proposalEmployeeName}
                                                                        columns={[
                                                                            {
                                                                                title: 'Shift Start Date',
                                                                                cellStyle: {
                                                                                    maxWidth: 20
                                                                                },
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                                        </React.Fragment>
                                                                                    )
                                                                                },
                                                                            },
                                                                            {
                                                                                title: 'Shift',
                                                                                field: 'shiftName',
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <ShiftCardWithTooltip
                                                                                                shift={rowData.shiftInfo.shiftDetails}
                                                                                                actionType={rowData.actionType}
                                                                                            />
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }
                                                                            },
                                                                            {
                                                                                title: 'Location',
                                                                                field: 'location',
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <Typography className={classes.employeeNameText}>
                                                                                                {`${rowData.shiftInfo.shiftDetails.segments[0].orgJobRef.qualifier} `}
                                                                                            </Typography>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }

                                                                            },
                                                                            {
                                                                                title: 'Warning',
                                                                                headerStyle: {
                                                                                    textAlign: 'center'
                                                                                },
                                                                                field: 'warning',
                                                                                render: rowData => {
                                                                                    let warningMsgs;
                                                                                    if (rowData['warnings'].length) {
                                                                                        warningMsgs = rowData['warnings'].map(warn => (<ManagerWarningContent warning={warn} classes={classes} />));
                                                                                    }

                                                                                    return (
                                                                                        warningMsgs ?
                                                                                            <React.Fragment>
                                                                                                <WarnTooltip
                                                                                                    title={warningMsgs}>
                                                                                                    <Button className={classes.transparentButton}>
                                                                                                        <FontAwesomeIcon className={classes.faExclamationTriangle} icon={faExclamationTriangle} />
                                                                                                    </Button>
                                                                                                </WarnTooltip>
                                                                                            </React.Fragment>
                                                                                            :
                                                                                            null
                                                                                    )
                                                                                }

                                                                            }
                                                                        ]}
                                                                        data={rowData.swapProposalShiftInfo}
                                                                        options={{
                                                                            search: false,
                                                                            paging: false,
                                                                            draggable: false,
                                                                            maxBodyHeight: '68vh',
                                                                            headerStyle: {
                                                                                fontWeight: 900,
                                                                                fontSize: '14px',
                                                                                textDecoration: 'underline',
                                                                            },
                                                                            detailPanelType: 'single',
                                                                        }}

                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </React.Fragment>
                                                    )
                                                }
                                                break;
                                            case RequestTypes.openShift:
                                                return (
                                                    <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                        <Grid item xs={1} className={classes.detailPanelShift}>
                                                            <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={11} className={'manager-dashboard'}>
                                                            <EmployeeCalendar schedule={this.generateSchedule(rowData, 'to')} shiftDate={rowData.shift.startDateTime} />
                                                        </Grid>
                                                    </Grid>
                                                )
                                            case RequestTypes.voluntaryTimeOff:
                                                let schedules = this.generateSchedule(rowData, 'to')

                                                let eeScheduleStartDates = schedules.map(d => moment(d.start))
                                                let eeScheduleEndDates = schedules.map(d => moment(d.end))

                                                let startOfWeekDate = moment.min(eeScheduleStartDates).utc().clone().day(0)//this sunday
                                                let endOfWeekDate = moment.max(eeScheduleEndDates).utc().clone().day(6) //this saturday

                                                let weeksCount = Math.ceil(endOfWeekDate.diff(startOfWeekDate, 'weeks', true))
                                                //find first affected shift
                                                let parsedShifts = rowData.shifts.map(x => moment(x.shiftInfo.startDateLocationTime))
                                                let firstAffectedShift = moment.min(parsedShifts)

                                                if (weeksCount <= 6) {
                                                    return (
                                                        <Grid container className={clsx(classes.detailPanel, 'more-detail')}>
                                                            <Grid item xs={12} className={classes.detailPanelShift}>
                                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{startOfWeekDate.format(MomentFormats.VERBOSE_LONG_DATE_WITH_DAY)} to {endOfWeekDate.format(MomentFormats.VERBOSE_LONG_DATE_WITH_DAY)} </Typography>
                                                            </Grid>
                                                            <Grid item xs={1} className={classes.detailPanelShift}>
                                                                <Typography component={'h2'} className={classes.employeeNameDetail} align={'center'}>{rowData.employeeTo.name}</Typography>
                                                            </Grid>
                                                            <Grid item xs={11} className={'manager-dashboard'}>
                                                                <EmployeeCalendar
                                                                    schedule={schedules}
                                                                    shiftDate={firstAffectedShift}
                                                                    weeksCount={weeksCount} />
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <React.Fragment>
                                                            <Grid container style={{ backgroundColor: '#e4eaf0' }}  >
                                                                <Grid items xs={12} style={{ padding: 5 }} >
                                                                    <MaterialTable
                                                                        icons={tableIcons}
                                                                        title={''}
                                                                        columns={[
                                                                            {
                                                                                title: 'Shift Start Date',
                                                                                cellStyle: {
                                                                                    maxWidth: 20
                                                                                },
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            {getAsLongDate(rowData.shiftInfo.shiftDetails.startDateTime)}
                                                                                        </React.Fragment>
                                                                                    )
                                                                                },
                                                                            },
                                                                            {
                                                                                title: 'Shift',
                                                                                field: 'shiftName',
                                                                                render: rowData => {
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <ShiftCardWithTooltip
                                                                                                shift={rowData.shiftInfo.shiftDetails}
                                                                                                actionType={RequestTypes.voluntaryTimeOff}
                                                                                            />
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }
                                                                            },
                                                                            {
                                                                                title: 'Location',
                                                                                field: 'location',
                                                                                render: rowData => {
                                                                                    const firstValidSegment = rowData.shiftInfo.shiftDetails.segments.find(segment => segment.type !== ShiftSegmentTypeName.BREAK_SEGMENT)
                                                                                    return (
                                                                                        <React.Fragment>
                                                                                            <Typography className={classes.employeeNameText}>
                                                                                                {`${firstValidSegment && firstValidSegment.orgJobRef.qualifier} `}
                                                                                            </Typography>
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }

                                                                            },
                                                                        ]}
                                                                        data={_.sortBy(rowData.shifts, ['shiftInfo.startDateLocationTime'])}
                                                                        options={{
                                                                            search: false,
                                                                            paging: false,
                                                                            draggable: false,
                                                                            maxBodyHeight: '40vh',
                                                                            headerStyle: {
                                                                                fontWeight: 900,
                                                                                fontSize: '14px',
                                                                                textDecoration: 'underline',
                                                                            },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>

                                                        </React.Fragment>
                                                    )

                                                }
                                            default:
                                                break;
                                        }
                                    }
                                })
                            ]}
                        options={{
                            search: false,
                            paging: false,
                            draggable: false,
                            maxBodyHeight: '65vh',
                            headerStyle: {
                                fontWeight: 900,
                                fontSize: '14px',
                                textDecoration: 'underline',
                            },
                            detailPanelType: 'single',
                            selection: true,
                            selectionProps: (rowData) => {
                                const isDisabled = !!([RequestStatus.RetractedSubmitted, RequestStatus.Approved, RequestStatus.Refused].includes(rowData.status.value) ||
                                    //signUp is already selected && rowData is not a sign up with active submission period
                                    (signUpRequestSelected && !activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId)) ||
                                    //selected is not signup && rowData is a sign up with active submission period
                                    (isNonActiveSignUpRequestSelected && activeSubmissionPeriodSettingsWithAwarding.includes(rowData.managerSettingAggregateRootId)))

                                rowData.tableData.disabled = isDisabled;

                                return {
                                    disabled: isDisabled
                                }
                            },
                            sorting: true,

                        }}
                        onSelectionChange={onCheckedRequest}
                        components={{
                            Toolbar: props => (
                                <div>
                                    <Grid container >
                                        <Grid item xs={3} md={3}>
                                            <MTableToolbar {...props} />
                                        </Grid>
                                        <Grid item xs={7} md={7}>

                                        </Grid>
                                        <Grid item xs={2} md={2} style={{ textAlign: "right", padding: "7px" }} >
                                            <Grid container>
                                                <Grid item xs={6} md={6}>
                                                    <Typography className={classes.labelButtons} style={{ paddingTop: "14px" }}>Rows per page: </Typography>
                                                </Grid>
                                                <Grid item xs={6} md={6}>
                                                    <ReactSelect
                                                        value={this.props.selectedFetchSize}
                                                        options={this.props.fetchSizeOptions}
                                                        onChange={this.handleSelectFetchSize}
                                                        customStyles={{
                                                            control: styles => ({
                                                                ...styles,
                                                                margin: '5px 5px 5px 5px',
                                                                border: '1px solid #CCCCCC',
                                                                padding: 3,
                                                                height: 25,
                                                                minWidth: 91
                                                            }),
                                                            menu: styles => ({
                                                                ...styles,
                                                                zIndex: 100
                                                            })
                                                        }}
                                                        selectWrapperClass={classes.selectWrapper}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </div>
                            ),
                            Body: (props) => {
                                if (props.renderData.length > 0) {
                                    return (
                                        <React.Fragment>
                                            <MTableBody {...props} />
                                            <tfoot>
                                                <tr >
                                                    <td style={{ textAlign: 'center' }} colSpan="9">
                                                        <div>
                                                            <Typography className={classes.labelViews}>You've viewed {fetchResultData.viewed} of {fetchResultData.total} requests</Typography>
                                                        </div>
                                                        <div>
                                                            <Button mt={1} hidden={this.props.addMoreDisable} className={classes.buttonAddMore} onClick={() => this.props.addMoreRequests()}>
                                                                <Typography className={classes.labelButtons}>Load more requests</Typography>
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </React.Fragment>
                                    )
                                }
                                else {
                                    return (
                                        <React.Fragment>
                                            <MTableBody {...props} />
                                        </React.Fragment>
                                    )
                                }
                            }
                        }}
                    />
                    <SideBar
                        handleDrawerClose={() => this.closeSidePanel()}
                        open={isSidePanelOpen}
                        title={< Typography className={classes.SideBarTitle} > {t('manager.history')}</Typography >}
                    >
                        <HistoryPanel
                            historyResponse={historyPanelData}
                            managerSettingNames={[]}
                        />
                    </SideBar>
                </MuiThemeProvider>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        data: state.data,
        selectedFetchSize: state.selectedFetchSize,
        fetchSizeOptions: state.fetchSizeOptions
    }
}
const mapDispatchToProps = {
    updateFetchSizeOption
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(withStyles(ManagerTableViewStyles)(RequestTable)));